import client from '@/api/client';
import { BASE_URL } from '@/constants';
import { utils } from '@sfaas/util';

export default {
	getUseYnList: ({ plantCd, commCdType }) => {
		return client
			.post(`${BASE_URL}/cc/v1/plants/${plantCd}/commonCodes?commCdType=${commCdType}`)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error;
			});
	},

	select: ({ params, currentPage, pageUnit }) => {
		const queryParams = utils.$sf_objectToQueryString({ ...params, currentPage, pageUnit });
		return client
			.get(`${BASE_URL}/notification/v1/select${queryParams}`)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error;
			});
	},

	register: ({ notiTitle, notiContent, plantCd }) => {
		return client
			.post(`${BASE_URL}/notification/v1/register`, { notiTitle, notiContent, plantCd })
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error;
			});
	},

	modify: ({ notiTitle, notiContent, useYn, notiSeq }) => {
		return client
			.post(`${BASE_URL}/notification/v1/update`, { notiTitle, notiContent, useYn, notiSeq })
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error;
			});
	},

	delete: ({ seqList }) => {
		return client
			.post(`${BASE_URL}/notification/v1/delete`, seqList)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error;
			});
	}
};
